module.exports = __webpack_public_path__ + "img/image2.dc69def0.png";